module.exports = __webpack_public_path__ + "img/瓜蒌子.466362ba.jpg";